import Provider, { useAuthState, useAuthDispatch } from "./AuthProvider";
const AuthProvider = {};
AuthProvider.Provider = Provider;
AuthProvider.useAuthState = useAuthState;
AuthProvider.useAuthDispatch = useAuthDispatch;
export default AuthProvider;